//LocalHost

export let CONFIG = {
    Settings: {
        CLIENT_ID: '26226e5e-c273-47fc-81dc-76d3d5002abd', // https://apps.dev.microsoft.com’
        TENANT_ID: 'd7f86710-01e1-461d-8599-758de4542e2b', // found in Azure->Active Directory->Properties Pane, TennantID = Directory ID
        AUTHORITY: 'https://login.microsoftonline.com/espoch.edu.ec/',

        RESPONSE_TYPE: 'id_token',
        RESPONSE_MODE: 'id_token',
        STATE: '',
        MS_GRAPH_URI: 'https://graph.microsoft.com/',
        REDIRECT_URI: 'https://becas.espoch.edu.ec/ingreso',
        POST_LOGOUT_REDIRECT: 'https://becas.espoch.edu.ec/ingreso',
        MSGRAPH_BETA_API: 'https://graph.microsoft.com/beta/',
        MSGRAPH_v1_API: 'https://graph.microsoft.com/v1.0/',
        SCOPES: ['User.Read'],
        ADMIN_CONSENT: true
    }
};

///Dominio Local Prueba
/*export let CONFIG = {
    Settings: {
        CLIENT_ID: '95d43a82-e658-48fb-a1ad-d07eeba6b2eb', // https://apps.dev.microsoft.com’
        TENANT_ID: 'd7f86710-01e1-461d-8599-758de4542e2b', // found in Azure->Active Directory->Properties Pane, TennantID = Directory ID
        AUTHORITY: 'https://login.microsoftonline.com/espoch.edu.ec/',

        RESPONSE_TYPE: 'id_token',
        RESPONSE_MODE: 'id_token',
        STATE: '',
        MS_GRAPH_URI: 'https://graph.microsoft.com/',
        REDIRECT_URI: 'https://pruebasw.espoch.edu.ec:5050/ingreso',
        POST_LOGOUT_REDIRECT: 'https://pruebasw.espoch.edu.ec:5050/ingreso',
        MSGRAPH_BETA_API: 'https://graph.microsoft.com/beta/',
        MSGRAPH_v1_API: 'https://graph.microsoft.com/v1.0/',
        SCOPES: ['User.Read'],
        ADMIN_CONSENT: true
    }
};*/

//Servidor Produccion

/*export let CONFIG = {
    Settings: {
       CLIENT_ID: 'fdc35fe1-2393-45cf-98b4-d75b2a383bec', // https://apps.dev.microsoft.com’
        TENANT_ID: 'd7f86710-01e1-461d-8599-758de4542e2b', // found in Azure->Active Directory->Properties Pane, TennantID = Directory ID
        AUTHORITY: 'https://login.microsoftonline.com/espoch.edu.ec/',
        RESPONSE_TYPE: 'id_token',
        RESPONSE_MODE: 'id_token',
        STATE: '',
        MS_GRAPH_URI: 'https://graph.microsoft.com/',
        REDIRECT_URI: 'https://comprobanteelectronico.espoch.edu.ec/',
        POST_LOGOUT_REDIRECT: 'https://comprobanteelectronico.espoch.edu.ec/',
        MSGRAPH_BETA_API: 'https://graph.microsoft.com/beta/',
        MSGRAPH_v1_API: 'https://graph.microsoft.com/v1.0/',
        SCOPES: ['User.Read'],
        ADMIN_CONSENT: true
    }
};*/

